import { render } from "./BtnLoginGoogle.vue?vue&type=template&id=8f5468e8"
import script from "./BtnLoginGoogle.vue?vue&type=script&lang=js"
export * from "./BtnLoginGoogle.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__